import { Link } from "react-router-dom";
import { ArrowUpRight, Images, MapPin } from "lucide-react";
import { brl, catLabel, fmtDate, img } from "@/lib/api";

export const EventCard = ({ ev }) => (
  <Link to={`/eventos/${ev.slug}`} data-testid={`event-card-${ev.slug}`}
    className="group block overflow-hidden rounded-[1.5rem] border border-white/10 bg-ink-2 transition-[border-color,transform] duration-500 hover:-translate-y-1 hover:border-flash/40">
    <div className="relative aspect-[4/3] overflow-hidden bg-ink-3">
      {ev.cover_photo_id ? (
        <img src={img("thumb", ev.cover_photo_id)} alt={ev.title} loading="lazy" className="h-full w-full object-cover transition-transform duration-[1.2s] group-hover:scale-105" />
      ) : (
        <div className="grid h-full place-items-center text-haze"><Images className="h-8 w-8" /></div>
      )}
      <span className="absolute left-4 top-4 rounded-full bg-ink/80 px-3 py-1 font-mono text-[11px] uppercase tracking-wider backdrop-blur">{catLabel(ev.category)}</span>
      <span className="absolute right-4 top-4 grid h-10 w-10 place-items-center rounded-full bg-flash text-ink opacity-0 transition-[opacity,transform] duration-500 group-hover:rotate-45 group-hover:opacity-100">
        <ArrowUpRight className="h-5 w-5" />
      </span>
    </div>
    <div className="p-5">
      <p className="font-mono text-xs text-haze">{fmtDate(ev.date)} · {ev.photo_count ?? 0} fotos</p>
      <h3 className="mt-2 font-display text-xl font-bold leading-tight">{ev.title}</h3>
      <div className="mt-4 flex items-center justify-between text-sm">
        <span className="inline-flex items-center gap-1.5 text-haze"><MapPin className="h-3.5 w-3.5" />{ev.location || "—"}</span>
        <span className="font-semibold text-flash">{brl(ev.price_per_photo_cents)}/foto</span>
      </div>
    </div>
  </Link>
);
